import request from './request'

//任务列表
export function templateTaskGetList(params) {
  return request({
    url: '/template-task/list',
    method: 'get',
    params
  })
}

// 任务分类
export function templateTaskGetCategList() {
  return request({
    url: '/template-task/category/list',
    method: 'get'
  })
}

//任务详情
export function templateTaskDetail(id) {
  return request({
    url: '/template-task/detail/' + id,
    method: 'get',
  })
}

//创建任务
export function templateTaskCreate(data) {
  return request({
    url: '/template-task/create',
    method: 'post',
    data
  })
}

// 模板导出
export function templateTaskExport(data) {
  return request({
    url: '/template-task/generateExcel',
    method: 'post',
    data
  })
}

// 导出列表
export function templateGetExcelRecord(params) {
  return request({
    url: '/template-task/get_excel_records',
    method: 'get',
    params
  })
}

// 导出成表格
export function templateTaskExportExcel(data) {
  return request({
    url: '/template-task/export-material-images',
    method: 'post',
    data
  })
}

// 备注
export function templateTaskRemark(id, data) {
  return request({
    url: '/template-task/update/' + id,
    method: 'post',
    data
  })
}
